export default "__VITE_ASSET__gb5YZ2WX__"